export default __webpack_public_path__ + "static/media/little-city.18344033.png";